import './webpack';
import _ from 'underscore';
import * as bundle from 'bundle';
import config from 'config';
import core from 'core';
import i18n from 'i18n';
import launcher from 'modules/launcher/launcher';
import user from 'user';
import BaseView from 'common/base.view';
import JackpotInstance from 'replacers/jackpot/jackpot.model.instance';
import 'util/device.util';
import 'modules/api/api';
import 'util/replacer.util';
import replacer from 'util/replacer.util';
import LoginView from 'portlets/login/login.view';
import MenuView from 'modules/menu/menu.view';

import 'managers/notification.manager.instance';
import 'modules/trackers/game.tracker.instance';
import 'managers/animation.manager.instance';
// imports are needed for corejs useBuiltIns: 'entry' option
// 'entry' option slightly reduces the bundle size
import 'regenerator-runtime/runtime';
import 'core-js/stable';

const dispatcher = bundle.dispatcher;

replacer.init();

/**
 * Register Backbone portlets in React here, so that licensee override can work.
 */
bundle.registerPortlets({
    'portlets_bingo_scheduler_bingo_scheduler_model': async () => import(/* webpackChunkName: "bingo-scheduler-bb" */ 'portlets/bingo-scheduler/bingo-scheduler.model'),
    'portlets_cashier_iframe_cashier_iframe_model': async () => import(/* webpackChunkName: "cashier-iframe-bb" */ 'portlets/cashier-iframe/cashieriframe.model'),
    'portlets_games_info_games_info_model': async () => import(/* webpackChunkName: "games-info-bb" */ 'portlets/games-info/gamesinfo.model'),
    'portlets_cashier_cashier_model': async () => import(/* webpackChunkName: "cashier-bb" */ 'portlets/cashier/cashier.model'),
    'portlets_bonus_multiview_bonus_multiview_model': async () => import(/* webpackChunkName: "bonus-multi-view-bb" */ 'portlets/bonus-multiview/bonusmultiview.model'),
    'portlets_registration_registration_model': async () => import(/* webpackChunkName: "registration-bb" */ 'portlets/registration/registration.model'),
    'portlets_responsible_gaming_responsible_gaming_model': async () => import(/* webpackChunkName: "responsible-gaming-bb" */ 'portlets/responsible-gaming/responsible-gaming.model'),
    'portlets_header_header_model': async () => import(/* webpackChunkName: "header-bb" */ 'portlets/header/header.model'),
    'portlets_login_login_view': LoginView,
    'modules_menu_menu_view': MenuView,
    'common_base_view':  BaseView,
    'replacers_jackpot_jackpot_model_instance': JackpotInstance,
});

/**
 * Propagate configuration from React to Backbone.
 */
dispatcher.listen('app:config', (app) => {
    config.load(app);
    core.trigger('app:initialResourcesLoaded');
});

dispatcher.listen('page:config', (page) => {
    config.load({ page });
    core.trigger('page:initialResourcesLoaded');
});

/**
 * Propagate translations from React to Backbone.
 */
dispatcher.listen('i18n:system:translations', (translations) => {
    i18n.setSystemTranslations(translations);
    core.trigger('app:translationsLoaded');
});

dispatcher.listen('i18n:page:translations', (translations) => {
    i18n.setPageTranslations(translations);
    core.trigger('app:translationsLoaded');
});

dispatcher.listen('i18n:pageInPopup:translations', (translations) => {
    i18n.setPageInPopupTranslations(translations);
    core.trigger('app:translationsLoaded');
});

/**
 * Connect with launcher
 */
dispatcher.listen('game:launch', function(data) {
    launcher.launchGame(data.code, data.mode, data.queryString, {
        isReactGame: true,
        container: data.container,
        gameFeed: data.gameFeed,
        gameName: data.gameName,
        onGameLaunched: data.onGameLaunched
    });
});

/**
 * Bi-directional sync with user model and User Context in React
 */
dispatcher.listen('user:details:update', function(data) {
    const contactPreferences = user.get('userDetails').contactPreferences
        .reduce(function(memo, preference) {
            const newPreference = data.find(function(item) {
                return item.type === preference.type && item.channel === preference.channel;
            });

            memo.push(newPreference || preference);

            return memo;
        }, []);

    user.set('userDetails', _.extend(
        {},
        user.get('userDetails'),
        { contactPreferences: contactPreferences }
    ));
});

dispatcher.listen('user:registrationInfo:fromFB', function(data) {
    user.set('registrationInfo', _.extend(
        {},
        user.get('registrationInfo'),
        data.regInfo
    ));

    core.navigate(data.facebookSuccessURL);
});

/**
 * Pass back VF jackpots to Backbone from React Jackpot Context
 */
dispatcher.listen('jackpots:vf', jackpotsData => JackpotInstance.updateJackpots([jackpotsData]));

/**
 * Pass back Casino jackpots to Backbone from React Jackpot Context
 */
dispatcher.listen('jackpots:casino', jackpotsData => {
    JackpotInstance.updateJackpots(config.get('useServicesVfJackpots') ? [{}, jackpotsData] : [jackpotsData]);
});

/**
 * Add login logout classes
 */
dispatcher.listen('auth:login', () => {
    document.querySelector('#application').classList.add('logged');
    document.querySelector('#application').classList.remove('loged-out');
});

dispatcher.listen('auth:logout', () => {
    document.querySelector('#application').classList.remove('logged');
    document.querySelector('#application').classList.add('loged-out');
});

/**
 * menu Items from react.
 */
 dispatcher.listen('menu:items', (menuItems) => {
    config.load({ menuItems: menuItems });
});

/**
 * games data from react.
 */
 dispatcher.listen('games:data', (gamesData) => {
    config.load(gamesData);
});

/**
 * forms data from react.
 */

dispatcher.listen('forms:data', (formsData) => {
    config.load(formsData);
});

/**
 * Main render of the application.
 */
const selector = '#application';
const container = document.querySelector(selector);

bundle.renderApp({ container });

/**
 * Support for react-snap, marking server-side pre-rendering
 */
window.snapSaveState = () => container.setAttribute('data-server-rendered', 'true');

core.trigger('app:rendered'); // DEL
